import { useEffect } from 'react';

import { useFormContext } from 'react-hook-form';

import { FieldRendererProps } from '../types';

const HiddenField = ({ field }: FieldRendererProps) => {
  const { register, setValue } = useFormContext();

  useEffect(() => {
    if (field.default_value) {
      setValue(field.name, field.default_value);
    }
  }, [field.default_value, field.name, setValue]);

  return <input type="hidden" {...register(field.name)} />;
};

export default HiddenField;
